import PropTypes from 'prop-types';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';
import { FreeMode, Pagination, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useState } from 'react';
import { useSelector } from 'react-redux';

import Image from 'components/global/Image';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import * as S from './SalesChannelDetail.styled';

const MobileGallery = ({ images }) => (
	<Swiper pagination={true} modules={[Pagination]} className="mobile-gallery">
		{images?.map((image) => (
			<SwiperSlide key={image}>
				<Image url={image} />
			</SwiperSlide>
		))}
	</Swiper>
);

MobileGallery.propTypes = {
	images: PropTypes.arrayOf(PropTypes.string)
};

const DesktopGallery = ({ images }) => {
	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	return (
		<>
			<Swiper
				spaceBetween={10}
				thumbs={{ swiper: thumbsSwiper }}
				modules={[FreeMode, Thumbs]}
				className="swiper-container">
				{images?.map((image) => (
					<SwiperSlide key={image}>
						<Image url={image} />
					</SwiperSlide>
				))}
			</Swiper>
			<Swiper
				onSwiper={setThumbsSwiper}
				spaceBetween={10}
				slidesPerView={3}
				freeMode={true}
				watchSlidesProgress={true}
				modules={[FreeMode, Thumbs]}
				className="swiper-thumbs-container">
				{images?.map((image) => (
					<SwiperSlide key={image}>
						<Image url={image} />
					</SwiperSlide>
				))}
			</Swiper>
		</>
	);
};

DesktopGallery.propTypes = {
	images: PropTypes.arrayOf(PropTypes.string)
};

const SalesChannelGallery = () => {
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const { salesChannel } = useSelector((state) => state.salesChannel);

	return (
		<S.Gallery>
			{isMobile ? (
				<MobileGallery images={salesChannel?.images} />
			) : (
				<DesktopGallery images={salesChannel?.images} />
			)}
		</S.Gallery>
	);
};

export default SalesChannelGallery;
